import type React from 'react';

import { useTranslation } from 'react-i18next';

import { BaseResultItem } from './base-result-item/BaseResultItem';
import type { TResultStatus } from '../../check-tag/CheckTag';
import { CheckTag } from '../../check-tag/CheckTag';

interface DeepfakeResultItemProps {
  prediction: string;
  score: number;
}

const kindMap: Record<string, TResultStatus> = {
  fake: 0,
  real: 1,
};

function DeepfakeResultItem({
  prediction,
  score,
}: DeepfakeResultItemProps): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <BaseResultItem
      label={t('Deepfake')}
      score={score}
      tag={(
        <CheckTag
          kind={kindMap[prediction] as TResultStatus}
          value={t(`checks:result panel.results.deepfake_states.${prediction}`)}
        />
      )}
    />
  );
}

export { DeepfakeResultItem };
